<div class="layout">
  <aside class="sidebar" [class.collapsed]="isCollapsed">
    <div class="brand">
      <img src="assets/images/isotipo-check.png" [alt]="isCollapsed ? 'iConstruye Check' : 'iConstruye'" class="brand__logo" />
      @if (!isCollapsed) {
        <span class="brand__title">Check</span>
      }
      <button class="toggle-btn" (click)="toggleSidebar()">
        <i class="pi" [ngClass]="isCollapsed ? 'pi-chevron-right' : 'pi-chevron-left'"></i>
      </button>
    </div>
    <nav>
      @if (viewModeService.isClientView()) {
        @if (veHome) {
        <a class="text-lg" routerLink="/pages/home" routerLinkActive="active" [pTooltip]="isCollapsed ? 'Mi Registro' : ''" tooltipPosition="right">
          <i class="pi pi-fw pi-home menu-icon" aria-hidden="true"></i>
          @if (!isCollapsed) {
            <span>Mi Registro</span>
          }
        </a>
        }
        @if (ve('socios')) {
        <a class="text-lg" routerLink="/pages/business-partners" routerLinkActive="active" [pTooltip]="isCollapsed ? 'Mis Socios de Negocio' : ''" tooltipPosition="right">
          <i class="pi pi-fw pi-users menu-icon" aria-hidden="true"></i>
          @if (!isCollapsed) {
            <span>Mis Socios de Negocio</span>
          }
        </a>
        }
        @if (ve('directorio')) {
        <a class="text-lg" routerLink="/pages/directorio" routerLinkActive="active" [pTooltip]="isCollapsed ? 'Directorio' : ''" tooltipPosition="right">
          <i class="fa-light fa-address-book fa-fw menu-icon" aria-hidden="true"></i>
          @if (!isCollapsed) {
            <span>Directorio</span>
          }
        </a>
        }
        @if (ve('acreditaciones')) {
        <a class="text-lg" routerLink="/pages/acreditaciones" routerLinkActive="active" [pTooltip]="isCollapsed ? 'Acreditaciones' : ''" tooltipPosition="right">
          <i class="pi pi-fw pi-verified menu-icon" aria-hidden="true"></i>
          @if (!isCollapsed) {
            <span>Acreditaciones</span>
          }
        </a>
        }
        <a class="text-lg" routerLink="/pages/tasks" routerLinkActive="active" [pTooltip]="isCollapsed ? 'Mis Tareas' : ''" tooltipPosition="right">
          <i class="pi pi-fw pi-check-square menu-icon" aria-hidden="true"></i>
          @if (!isCollapsed) {
            <span>Mis Tareas</span>
          }
        </a>
      }
      <!--<a routerLink="/pages/dashboard" routerLinkActive="active"><i class="pi pi-fw pi-chart-bar menu-icon" aria-hidden="true"></i>Dashboard</a>-->

    @if (viewModeService.isClientView() && ve('configuracion')) {
      <a class="text-lg" routerLink="/pages/settings" routerLinkActive="active" [pTooltip]="isCollapsed ? 'Configuración' : ''" tooltipPosition="right">
        <i class="pi pi-fw pi-cog menu-icon" aria-hidden="true"></i>
        @if (!isCollapsed) {
          <span>Configuración</span>
        }
      </a>
    }
    @if (viewModeService.isSupplierView()) {
      <a class="text-lg" routerLink="/pages/information-requests" routerLinkActive="active" [pTooltip]="isCollapsed ? 'Solicitudes de Información' : ''" tooltipPosition="right">
        <i class="pi pi-fw pi-inbox menu-icon" aria-hidden="true"></i>
        @if (!isCollapsed) {
          <span>Solicitudes de Información</span>
        }
      </a>
    }
    @if (viewModeService.isSupplierView()) {
      <a class="text-lg" routerLink="/pages/shared-information" routerLinkActive="active" [pTooltip]="isCollapsed ? 'Información Compartida' : ''" tooltipPosition="right">
        <i class="pi pi-fw pi-folder-open menu-icon" aria-hidden="true"></i>
        @if (!isCollapsed) {
          <span>Información Compartida</span>
        }
      </a>
    }
  </nav>
</aside>
<main class="main">

  <router-outlet></router-outlet>
</main>
@if (viewModeService.isClientView()) {
  <app-create-supplier-modal/>
}
<app-snack-bar></app-snack-bar>
</div>
